import { Directive, ElementRef, HostListener, Input, OnInit, Renderer2, inject } from '@angular/core';

@Directive({ selector: '[appStickyFormButtons]' })
export class StickyFormButtonsDirective implements OnInit {
    private elementRef = inject(ElementRef);
    private renderer = inject(Renderer2);


    @Input() stickyEnabled = true;

    anchoredDiv: HTMLElement;
    resizeObserver: ResizeObserver;

    @HostListener('window:scroll') // for window scroll events
    @HostListener('window:resize')
    onScroll(): void {
        this.makeSticky();
    }

    ngOnInit(): void {
        if (this.stickyEnabled) {
            this.anchoredDiv = document.createElement('div');
            this.anchoredDiv.setAttribute('sticky-form-buttons-helper', '');
            this.renderer.insertBefore(this.elementRef.nativeElement.parentNode, this.anchoredDiv, this.elementRef.nativeElement);
            this.setupResizeObserver();
            this.makeSticky();
        }
    }

    setupResizeObserver(): void {
        this.resizeObserver = new ResizeObserver(entries => {
            for (const entry of entries) {
                if (entry.target === document.body) {
                    this.makeSticky();
                    break;
                }
            }
        });

        this.resizeObserver.observe(document.body);
    }


    makeSticky(): void {
        if (this.stickyEnabled) {
            const saveDiv = this.elementRef.nativeElement;
            const rect = this.anchoredDiv.getBoundingClientRect();

            if (rect.top > window.innerHeight && window.innerWidth >= 767 && window.innerHeight > 500) {
                //style class is in forms.scss
                saveDiv.classList.add('form-sticky-form-buttons-on');
            } else {
                saveDiv.classList.remove('form-sticky-form-buttons-on');
            }
        }
    }
}
